import useAppDispatch from 'hooks/useAppDispatch';
import { googleLoginAction } from 'store/modules/auth/actions';
import { useGoogleLogin } from '@react-oauth/google';
import { Box, Button } from '@mui/material';
import { Google } from '@mui/icons-material';
import { useStyles } from './styles';

interface GoogleButtonProps {
  isCompany: boolean;
}

function GoogleButton({ isCompany }: GoogleButtonProps) {
  const styles = useStyles();
  const dispatch = useAppDispatch();

  const onFailure = (data: any) => {
    console.error(data);
  };

  const onSuccess = (data: any) => {
    if (data.access_token) {
      dispatch(googleLoginAction(data.access_token, isCompany));
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (response) => onSuccess(response),
    onError: (error) => onFailure(error)
  });

  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={
        <Box className={styles.icon}>
          <Google
            sx={{
              fontSize: 12,
              fill: 'white'
            }}
          />
        </Box>
      }
      onClick={() => googleLogin()}
    >
      entrar com google
    </Button>
  );
}

export default GoogleButton;
